export default function accountListReducer(
    state: any = {
        accounts: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        generateStatement: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        generateBorderaux: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Tracker activity reducer
         */
        case 'FETCH_ACCOUNT_LIST_PENDING': {
            return { ...state, accounts: { ...state.accounts, loading: true, success: null } }
        }

        case 'FETCH_ACCOUNT_LIST_REJECTED': {
            return { ...state, accounts: { ...state.accounts, loading: false, error: action.payload, success: false } }
        }

        case 'FETCH_ACCOUNT_LIST_FULFILLED': {
            return {
                ...state, accounts:
                    { ...state.accounts, loading: false, done: true, error: null, response: action.payload },
            }
        }

        /**
         *     Tracker activity reducer
         */
        case 'GENERATE_STATEMENT_PENDING': {
            return { ...state, generateStatement: { ...state.generateStatement, loading: true, success: null } }
        }

        case 'GENERATE_STATEMENT_REJECTED': {
            return {
                ...state,
                generateStatement:
                    { ...state.generateStatement, loading: false, error: action.payload, success: false },
            }
        }

        case 'GENERATE_STATEMENT_FULFILLED': {
            return {
                ...state, generateStatement: {
                    ...state.generateStatement, loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        case 'GENERATE_BORDEREAUX_PENDING': {
            return { ...state, generateBorderaux: { ...state.generateBorderaux, loading: true, success: null } }
        }

        case 'GENERATE_BORDEREAUX_REJECTED': {
            return {
                ...state,
                generateBorderaux:
                    { ...state.generateBorderaux, loading: false, error: action.payload, success: false },
            }
        }

        case 'GENERATE_BORDEREAUX_FULFILLED': {
            return {
                ...state, generateBorderaux: {
                    ...state.generateBorderaux, loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        case 'REMOVE_ENTRY_FULFILLED': {
            return {
                ...state, accounts:
                    { ...state.accounts, loading: false, done: true, error: null, response: action.payload },
            }
        }

        case 'MARK_AS_PAID_FULFILLED': {
            return {
                ...state, accounts:
                    { ...state.accounts, loading: false, done: true, error: null, response: action.payload },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/accounts.ts